export default {
  app: {
    notFound: {
      title: 'Страница не найдена.',
      subtitle: 'Похоже, ты заблудился.',
      text: 'Не волнуйтесь, мы поможем вам сориентироваться здесь',
    },
  },
};
